import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/reallocateAll/billable`;

export const ROUTE: RouteDefinition = `${baseRoute}/reallocateAll/billable`;

export const URL = (): RouteDefinition => `${baseRoute}/reallocateAll/billable`;
